export abstract class ApiInterface {
  protected rootEndpoint: string;

  constructor(rootEndpoint: string) {
    this.rootEndpoint = `/${rootEndpoint}`;
  }
}
